const STRONG_PASSWORD_LENGTH = 16;

// Only ever loosen these rules: anything the form accepted before must keep passing, and the
// platform's license user password form applies the same set.
const passwordRules = [
  {
    key: 'length',
    label: 'At least 12 characters',
    error: 'Password must be at least 12 characters',
    test: (password) => password.length >= 12,
  },
  {
    key: 'lowercase',
    label: 'At least one lowercase letter (a-z)',
    error: 'Password must contain at least one lowercase letter',
    test: (password) => /[a-z]/.test(password),
  },
  {
    key: 'uppercase',
    label: 'At least one uppercase letter (A-Z)',
    error: 'Password must contain at least one uppercase letter',
    test: (password) => /[A-Z]/.test(password),
  },
  {
    key: 'digit',
    label: 'At least one digit (0-9)',
    error: 'Password must contain at least one digit',
    test: (password) => /[0-9]/.test(password),
  },
  {
    key: 'special',
    label: 'At least one special character (any symbol or space)',
    error: 'Password must contain at least one special character',
    test: (password) => /[^A-Za-z0-9]/.test(password),
  },
];

export const validatePasswordComplexity = (password) => {
  if (!password) {
    return ['Password is required'];
  }
  return passwordRules
    .filter((rule) => !rule.test(password))
    .map((rule) => rule.error);
};

export const isPasswordValid = (password) => {
  return validatePasswordComplexity(password).length === 0;
};

export const getPasswordRuleChecks = (password) =>
  passwordRules.map((rule) => ({
    key: rule.key,
    label: rule.label,
    met: rule.test(password || ''),
  }));

export const getPasswordStrength = (password) => {
  if (!password) {
    return '';
  }
  if (!isPasswordValid(password)) {
    return 'weak';
  }
  return password.length >= STRONG_PASSWORD_LENGTH ? 'strong' : 'fair';
};
